import Vue from 'vue'
import blocks from './editor/blocks'
import mods from './editor/mods'

const state = () => ({
  hideSidebar: false,
  isAppendable: false,

  // ready state used for detect editor first loaded or editing.
  ready: false,
  changed: false,
  // media support: 'desktop', 'mobile'
  media: 'desktop',
  zoom: 1,

  menuFocusing: null
})

const actions = {
  fetchProject({ commit, dispatch }, { id }) {
    return dispatch('projects/fetchItem', { id }, { root: true })
      .catch(err => {
        throw err
      })
  },

  reset({ commit, dispatch }) {
    dispatch('editor/blocks/reset', null, { root: true })
    dispatch('editor/mods/reset', null, { root: true })
    commit('RESET')
  },

  toggleSidebar({ state, commit }) {
    const type = state.hideSidebar ? 'OPEN_SIDEBAR' : 'CLOSE_SIDEBAR'
    commit(type)
  },

  appendable({ commit }) {
    commit('APPENDABLE')
  },

  unappendable({ commit }) {
    commit('UNAPPENDABLE')
  },

  // 變更專案資料但是不儲存，遠端資料亦不會改變
  assign({ commit, dispatch, getters }, data) {
    const project = getters.project
    dispatch('change')
    dispatch('projects/assign', { id: project.id, data }, { root: true })
  },

  // 儲存專案，將會變更遠端資料
  //
  // 目前只會傳送 blocks 與 project.meta 兩筆屬性
  save({ state, commit, dispatch, getters }) {
    const project = getters.project
    const blocks = state.blocks.list.map(id => state.blocks.cached[id])
    const data = {
      blocks,
      meta: project.meta
    }
    return dispatch('projects/update', { id: project.id, data }, { root: true })
      .then(() => commit('SAVED'))
  },

  ready({ commit }) {
    commit('READY')
  },

  // 使專案狀態改為已經變更且尚未儲存
  change({ state, commit }) {
    if (state.ready) {
      commit('CHANGE')
    }
  },

  // 切換編輯器目前的專案檢視模式
  viewAs({ commit }, type) {
    commit('VIEW_AS', type)
  },

  // 同步商品資料
  sync({ state, dispatch, commit }, id) {
    if (state.changed) {
      const err = new Error('編輯中的專案尚未儲存，請儲存後再進行商品同步資料，以避免資料遺失。')
      return Promise.reject(err)
    }
    return dispatch('projects/sync', id, { root: true })
      .then(project => {
        dispatch('editor/blocks/reset', null, { root: true })
        Vue.nextTick(() => dispatch('editor/blocks/add', { blocks: project.blocks }, { root: true }))

        // add synced blocks will making editor changed
        Vue.nextTick(() => commit('SAVED'))
      })
      .catch(err => {
        dispatch('alert/set', { code: err.code }, { root: true })
      })
  },

  // 編輯器放大檢視比例
  zoomin({ commit }) {
    return commit('ZOOMIN')
  },

  // 編輯器縮小檢視比例
  zoomout({ commit }) {
    return commit('ZOOMOUT')
  },

  // 編輯器重置檢視比例
  zoomReset({ commit }) {
    return commit('ZOOM_RESET')
  },

  menuFocus({ commit }, uid) {
    return commit('MENU_FOCUS', uid)
  }
}

const mutations = {
  RESET(_state) {
    const init = state()
    Object.keys(init).forEach(key => {
      _state[key] = init[key]
    })
  },

  OPEN_SIDEBAR(state) {
    state.hideSidebar = false
  },

  CLOSE_SIDEBAR(state) {
    state.hideSidebar = true
  },

  APPENDABLE(state) {
    state.isAppendable = true
  },

  UNAPPENDABLE(state) {
    state.isAppendable = false
  },

  CHANGE(state) {
    state.changed = true
  },

  SAVED(state) {
    state.changed = false
  },

  READY(state) {
    state.ready = true
  },

  VIEW_AS(state, type) {
    state.media = type
  },

  ZOOMIN(state) {
    if (state.zoom >= 1) {
      state.zoom = 1
      return
    }
    state.zoom += 0.25
  },

  ZOOMOUT(state) {
    if (state.zoom <= 0.25) {
      state.zoom = 0.25
      return
    }
    state.zoom -= 0.25
  },

  ZOOM_RESET(state) {
    state.zoom = 1
  },

  MENU_FOCUS(state, uid) {
    state.menuFocusing = uid
  }
}

const getters = {
  project(state, getters, rootState, rootGetters) {
    const id = rootState.route.params.project_id
    return rootGetters['projects/item'](id) || {}
  },

  hideSidebar(state) {
    return state.hideSidebar
  }
}

export default {
  namespaced: true,
  modules: { mods, blocks },
  state: state(),
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/editor.js